// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const TogetherShare = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m14.024 4.288-2.952 3.047-.38.286-.667-.667.286-.38 3.808-3.81.381-.285.38.286 3.81 3.808.285.381-.666.667-.381-.286-2.952-3.047v13.616h-.952V4.288Zm4.284 5.046h4.285V25.521H6.407V9.334h4.76v.953H7.36v14.281h14.282V10.287H17.832v-.952h.476Z"
			fill="#fff"
		/>
	</svg>
);
export default TogetherShare;
